import { render, staticRenderFns } from "./LfHeaderTitleComponent.vue?vue&type=template&id=ff3c31c0&scoped=true"
import script from "./LfHeaderTitleComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./LfHeaderTitleComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./LfHeaderTitleComponent.vue?vue&type=style&index=0&id=ff3c31c0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3c31c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff3c31c0')) {
      api.createRecord('ff3c31c0', component.options)
    } else {
      api.reload('ff3c31c0', component.options)
    }
    module.hot.accept("./LfHeaderTitleComponent.vue?vue&type=template&id=ff3c31c0&scoped=true", function () {
      api.rerender('ff3c31c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HeaderTitle/LfHeaderTitleComponent.vue"
export default component.exports